export default __webpack_public_path__ + "static/media/i_bus-dbl_pp.ab7b24c1.svg";